<script lang="ts">
  import type { TextAndLinkStoryblok } from "$types/components";
  import { storyblokEditable } from "@storyblok/svelte";
  import { parseUrl } from "$lib/utils/helpers.js";
  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor, IconType } from "$types/atoms";

  export let blok: TextAndLinkStoryblok;
  export let isLight = false;
  export let compact = false;
</script>

<a
  href={parseUrl(blok.link)}
  class="text-and-link"
  class:is-light={isLight}
  use:storyblokEditable={blok}
>
  <div class="content">
    <p class="label type:h6-large">{blok.label}</p>
    {#if blok.text && !compact}
      <p class="text type:body-large">{blok.text}</p>
    {/if}
  </div>

  <Button
    icon={IconType.ARROW_RIGHT}
    color={ButtonColor.GRAY}
    class="cta"
    label={blok.label}
  />
</a>

<style lang="scss">
  .is-light {
    color: rgb(var(--color-light-grey));
  }

  .text-and-link {
    text-decoration: none;
    color: inherit;
    padding: fluid(32px, 24px) 0;
    display: flex;
    border-top: 1px solid rgba(#242021, 0.1);
    align-items: center;
    justify-content: space-between;

    &:hover {
      :global(.button) {
        background: rgb(var(--color-red-secondary));
      }

      :global(.button svg) {
        color: rgb(var(--color-white));
      }
    }

    .content {
      padding-right: 32px;
    }
  }

  .label + .text {
    margin-top: fluid(8px, 8px);
  }
</style>
